import {
    getInitialLocaleFactory,
} from '../../../libs/IdeLink.Web.Common/src/services/i18n/I18nLocaleConfig';
import {
    I18nMessagesByLocale,
    I18nState,
} from '../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages';
import { frOxylinkMessages } from './fr/frAllOxylinkMessages';

export class OxylinkI18n {

    public static getI18State = (): I18nState => {

        const locale: string = getInitialLocaleFactory();
        const allMessages: I18nMessagesByLocale = { fr: frOxylinkMessages };

        return {
            locale,
            allMessages,
            messages: allMessages[locale],
        };
    };
}
